<template>
  <div class="app">
    <div class="w100">
      <div class="title">
        <!-- <h4>降噪产品体验</h4> -->
        <div @click="gotoform">典型场景降噪试听</div>
        <span id="toFormFree">sdfsdf</span>
        <div class="con-msg">
          <p v-for="(item, index) in Msg" :key="index">{{item}}</p>
        </div>
      </div>
    </div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-position="top"
      label-width="150px"
      class="submitform"
    >
      <el-form-item label="音频文件" prop="file">
        <div class="file">
          <el-tag
            :key="tag"
            v-for="tag in dynamicTags"
            closable
            :disable-transitions="false"
            @close="handleClose(tag)"
          >{{tag}}</el-tag>
          <el-upload
            action
            :on-change="handleChange"
            :auto-upload="false"
            :show-file-list="false"
            class="upload"
            v-if="rawFile.length <3"
          >
            <div class="new-tag" slot="trigger">新增文件</div>
          </el-upload>
        </div>
      </el-form-item>
      <el-form-item
        label="公司名称"
        prop="company"
        :rules="{
          required: true, message: '公司名称不能为空', trigger: 'blur'
        }"
      >
        <el-input v-model="ruleForm.company" placeholder="请填写您的公司名称"></el-input>
      </el-form-item>
      <el-form-item
        label="联系人"
        prop="name"
        :rules="{required: true, message: '联系人不能为空', trigger: 'blur'
        }"
      >
        <el-input v-model="ruleForm.name" placeholder="请填写联系人的姓名"></el-input>
      </el-form-item>
      <el-form-item
        label="邮箱"
        prop="mail"
        :rules="[
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur,change' }
        ]"
      >
        <el-input v-model="ruleForm.mail" placeholder="请填写您的电子邮箱"></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="phone">
        <el-input v-model.number="ruleForm.phone" placeholder="请填写您的手机号"></el-input>
      </el-form-item>
      <el-form-item
        label="需求概述"
        prop="note"
        :rules="[
           { required: true, message: '请简略描述您的需求', trigger: 'blur' }
        ]"
      >
        <el-input type="textarea" :rows="11" placeholder="请简要描述您的需求" v-model="ruleForm.note"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          :disabled="issubmit"
          @click="submitForm('ruleForm')"
          class="submitBotton"
        >发送合作意向</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { filePost } from '@/api/http.js'
import EQ from '@/components/common/js/eqObject'
export default {
  data () {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'))
      } else {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的手机号'))
        }
      }
    }
    var checkFile = (rule, value, callback) => {
      if (value === 0) {
        return callback(new Error('音频文件不能为空'))
      } else {
        callback()
      }
    }
    return {
      dynamicTags: [],
      rawFile: [],
      ruleForm: {
        company: '',
        name: '',
        mail: '',
        phone: '',
        model: '',
        file: 0,
        time: '',
        budget: '',
        note: ''
      },
      issubmit: false,
      Msg: ['为了保证音频降噪体验的严谨与高效，请上传需处理的音频文件，要求单段音频大小不', '超过6M，最多能体验3段。上传完成后请准确填写下表，我公司技术人员稍后会将处理好的', '音频文件发送给您。'],
      rules: {
        phone: [
          { validator: checkPhone, trigger: 'blur', required: true }
        ],
        file: [
          { validator: checkFile, trigger: 'blur', required: true }
        ]
      },
      oldSubmit: null,
      oldFile: []
    }
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let checkdata = {}
          let formdata = new FormData()
          formdata.append('budget', this.ruleForm.budget)
          formdata.append('companyName', this.ruleForm.company)
          formdata.append('contacts', this.ruleForm.name)
          formdata.append('email', this.ruleForm.mail)
          formdata.append('need', this.ruleForm.note)
          formdata.append('phone', this.ruleForm.phone)
          formdata.append('serviceModeEnum', this.ruleForm.model)
          formdata.append('startTime', this.ruleForm.time)

          checkdata['budget'] = this.ruleForm.budget
          checkdata['companyName'] = this.ruleForm.company
          checkdata['contacts'] = this.ruleForm.name
          checkdata['email'] = this.ruleForm.mail
          checkdata['need'] = this.ruleForm.note
          checkdata['phone'] = this.ruleForm.phone
          checkdata['serviceModeEnum'] = this.ruleForm.model
          checkdata['startTime'] = this.ruleForm.time

          for (let index = 0; index < this.rawFile.length; index++) {
            const element = this.rawFile[index]
            formdata.append('files', element.file)
          }

          if (!(EQ(checkdata, this.oldSubmit) && (this.dynamicTags.toString() === this.oldFile.toString()))) {
            this.issubmit = true
            this.$message.success('正在发送中')
            filePost('apply/save', formdata).then((el) => {
              if (el.success === true) {
                this.$message.success('申请发送成功')
                this.oldFile = JSON.parse(JSON.stringify(this.dynamicTags))
                this.oldSubmit = checkdata
              } else {
                this.$message.error('申请发送失败!')
              }
            }).catch(er => {
              this.$message.error('error post!!')
            })
            this.issubmit = false
          } else {
            console.log('重复提交')
            this.$message.success('您填写的信息已收到')
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    handleClose (tag) {
      const index = this.dynamicTags.indexOf(tag)
      this.dynamicTags.splice(index, 1)
      this.rawFile.splice(index, 1)
      this.ruleForm.file = this.rawFile.length
    },
    gotoform () {
      this.$router.push({
        name: 'SoundDenoise',
        params: {
          ScorldId: 'trylisten'
        }
      })
    },
    handleChange (file) {
      // const isWav = file.raw.type === 'audio/wav'
      const isLt8M = file.raw.size / 1024 / 1024 < 6
      if (!isLt8M) {
        this.$message.error('上传的音频大小不能超过 6MB!')
      } else if (this.rawFile.length > 3) {
        this.$message.error('最多上传3个音频文件')
      } else if (this.dynamicTags.indexOf(file.name) === -1) {
        this.dynamicTags.push(file.name)
        this.rawFile.push({ 'name': file.name, 'file': file.raw })
        this.ruleForm.file = this.rawFile.length
      } else {
        this.$message.error('请选择其他文件')
      }
    }
  }
}
</script>

<style scoped>
.app /deep/ .el-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  line-height: 72px;
  outline: 0;
  padding: 0 15px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  text-align: left;
  width: 800px;
  height: 72px;
  background: rgba(248, 248, 248, 1);
  border-radius: 4px;
}
.app /deep/ .el-select {
  display: inline-block;
  position: relative;
  width: 100%;
}
.app /deep/ .el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background: rgba(254, 245, 255, 1);
}
.app /deep/ .el-button--primary {
  width: 491px;
  height: 80px;
  background: rgba(74, 17, 118, 1);
  border: 0px;
  border-radius: 6px;
  margin-top: 107px;
  margin-bottom: 87px;
  font-size: 24px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
}
.app /deep/ .el-form-item {
  margin-bottom: 22px;
  text-align: left;
}
.app /deep/ .el-textarea__inner {
  display: block;
  resize: vertical;
  padding: 5px 15px;
  line-height: 1.5;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  font-size: 20px;
  color: #606266;
  background-image: none;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  text-align: left;
  width: 800px;
  height: 252px;
  background: rgba(248, 248, 248, 1);
}
.app /deep/ .el-form-item__label {
  text-align: right;
  vertical-align: middle;
  float: left;
  line-height: 70px;
  padding: 0 12px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 24px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}
.app /deep/ .el-select-dropdown__item {
  font-size: 20px;
  padding: 4px 21px;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #606266;
  height: 55px;
  line-height: 40px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  cursor: pointer;
}
.file /deep/ .el-tag {
  width: 200px;
  height: 46px;
  background: rgba(238, 238, 238, 1);
  border: 1px solid rgba(205, 205, 205, 1);
  border-radius: 4px;
  font-size: 18px;
  line-height: 46px;
  margin-top: 25px;
  font-weight: normal;
  color: rgba(51, 51, 51, 1);
  float: left;
  margin-top: 25px;
  margin-left: 40px;
}
.file /deep/ .el-tag .el-icon-close {
  text-align: center;
  position: relative;
  cursor: pointer;
  font-size: 12px;
  width: 24px;
  height: 24px;
  line-height: 24px;
  vertical-align: middle;
  top: -25px;
  right: -61px;
  background: rgba(210, 210, 210, 1);
  border-radius: 50%;
}
.file /deep/ .el-tag .el-tag__close {
  color: #f5f7fa;
}
.file /deep/ .el-button--small,
.el-button--small.is-round {
  padding: 0px 0px;
  margin-top: 25px;
  width: 200px;
  height: 46px;
  border: 1px solid rgba(74, 17, 118, 1);
  border-radius: 4px;
  font-size: 18px;
  font-weight: normal;
  color: rgba(74, 17, 118, 1);
}
h4,
.title h4 {
  font-size: 30px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
}
.title {
  position: relative;
}
#toFormFree {
  position: absolute;
  visibility: hidden;
  top: 66px;
}
.title > :first-child {
  width: 240px;
  height: 62px;
  background: rgba(74, 17, 118, 1);
  border-radius: 4px;
  font-size: 22px;
  font-weight: normal;
  line-height: 62px;
  color: rgba(255, 255, 255, 1);
  margin-top: 74px;
  margin-bottom: 65px;
}
.app .w100 .title p {
  text-align: left;
  font-size: 20px;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  margin-bottom: -25px;
}
.app .w100 .title :nth-child(3) :first-child {
  text-indent: 2em;
}
.app .w100 .title :last-child {
  margin-bottom: 30px;
  width: 990px;
}
.file {
  width: 800px;
  height: 100px;
  border: 1px solid rgba(161, 161, 161, 1);
  border-radius: 4px;
  margin-top: 86px;
  background-color: white;
}
.upload {
  width: 200px;
  height: 46px;
  border: 1px solid rgba(74, 17, 118, 1);
  border-radius: 4px;
  font-size: 18px;
  font-weight: normal;
  color: rgba(74, 17, 118, 1);
  display: block;
  float: left;
  margin-top: 25px;
  margin-left: 40px;
}
</style>

<style >
.el-message {
  min-width: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/form/cooperate.vue